import React from "react";
import { FaBell, FaHeart, FaDollarSign } from "react-icons/fa";
import "./HelpSection.css"; // ✅ import external CSS

const helpItems = [
  {
    icon: <FaBell size={40} color="#e0d319" />,
    title: "SPREAD THE WORD",
    description:
      "Help us by sharing information about KWT services so that others can avail them.",
    color: "#e0d319",
  },
  {
    icon: <FaHeart size={40} color="#e73434" />,
    title: "WORK WITH US",
    description: "Volunteer at KWT and do your part in serving the society.",
    color: "#e73434",
  },
  {
    icon: <FaDollarSign size={40} color="#12b300" />,
    title: "DONATE",
    description:
      "Donate to KWT and help us in helping others. Spread joy with a donation.",
    color: "#12b300",
  },
];

const HelpSection = () => {
  return (
    <section className="help-section">
      <div className="help-wrapper">
        <div className="help-heading-wrapper">
          <h2 className="help-heading">How Can You Help Us?</h2>
        </div>
        <div className="help-container">
          {helpItems.map((item, index) => (
            <div key={index} className="help-card">
              <div
                className="help-icon-wrapper"
                style={{ borderColor: item.color }}
              >
                {item.icon}
              </div>
              <h3 className="help-title">{item.title}</h3>
              <p className="help-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HelpSection;
